import { GET_PROFILE_FAILUER,GET_PROFILE_REQUEST,GET_PROFILE_SUCCESS } from "./types";

export const getprofilerequest=()=>{
    return{
        type: GET_PROFILE_REQUEST
    }
}
export const getprofilesuccess=(cred)=>{
    return{
        type: GET_PROFILE_SUCCESS,
        payload: cred

    }
}

export const getprofilefailure=(error)=>{
    return{
        type: GET_PROFILE_FAILUER,
        payload: error

    }
}


